import { ref } from "vue";
import { defineStore } from "pinia";
import { LicenseLimitReachedError } from "@core/errors/Errors";

export const useSubscriptionOrderingPopup = defineStore("ui/licenseOrderingPopup", () => {
  const visible = ref(false);
  const error = ref<null | LicenseLimitReachedError>(null);

  let resolvePromise: ((value: boolean) => void) | null = null;

  function show(e: LicenseLimitReachedError | null) {
    error.value = e;
    visible.value = true;

    return new Promise<boolean>((resolve) => {
      resolvePromise = resolve;
    });
  }

  function hide(value: boolean = false) {
    visible.value = false;
    if (resolvePromise) {
      resolvePromise(value);
      resolvePromise = null;
    }
  }

  return {
    visible,
    error,
    show,
    hide
  };
});